import VisibilityIcon from '@mui/icons-material/Visibility'
import {
	IconButton
} from '@mui/material'
import { useTheme } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'
import {setChartWidgetLines} from '../../../../../../store/redusers/chart/actions'
import {selectTradeLines} from '../../../../../../store/redusers/chart/selectors'
import {
	selectOpenSL,
	selectOpenTP
} from '../../../../../../store/redusers/positions/selectors'


const TableViewBtn = ({positionId, currentTab}) => {
	const positionTP = useSelector(selectOpenTP(currentTab, positionId))
	const positionSL = useSelector(selectOpenSL(currentTab, positionId))
	const tradeLines = useSelector(selectTradeLines)
	const {dispatch} = useDefaultComponentTools()
	const theme = useTheme()
	// eslint-disable-next-line
	const disabledView = (+positionTP === 10000000 || +positionTP === 0) && (+positionSL === 0 || +positionSL === 10000000)
	const handleClickView = () => {
		dispatch(setChartWidgetLines(positionId === tradeLines ? '' : positionId))
	}

	return (
		<IconButton onClick={handleClickView} disabled={disabledView} >
			< VisibilityIcon sx={{color: positionId === tradeLines ? theme.palette.blue : '', fontSize: 'small' }}/>
		</IconButton>
	)
}

TableViewBtn.propTypes = {
	currentTab: PropTypes.string,
	positionId: PropTypes.string
}


export default TableViewBtn
